import type { z } from "zod/v4";
import type { ZodFormSchema } from ".";
import type { DeepPartial } from "./deep-partial";

export function flattenZodFormErrors<T extends ZodFormSchema>(
  errors?: DeepPartial<z.infer<T>> | null
) {
  if (!errors) return new Map<string, string>();

  const flattenedErrorsMap = new Map<string, string>();

  // Flatten object errors
  function flatten(subErrors: Record<string, unknown>, prefix = "") {
    for (const [key, value] of Object.entries(subErrors)) {
      const newPrefix = prefix ? `${prefix}.${key}` : key;
      if (typeof value === "string") {
        flattenedErrorsMap.set(newPrefix, value);
      } else if (Array.isArray(value)) {
        value.forEach((item, index) => {
          if (typeof item === "string") {
            flattenedErrorsMap.set(`${newPrefix}.${index}`, item);
          } else {
            flatten(item as Record<string, unknown>, `${newPrefix}.${index}`);
          }
        });
      } else if (typeof value === "object" && value !== null) {
        flatten(value as Record<string, unknown>, newPrefix);
      }
    }
  }

  flatten(errors as unknown as Record<string, unknown>);

  return flattenedErrorsMap;
}
